import { Component, OnInit } from "@angular/core";
import { OrderService } from "../../../../app/main/order-management/order.service";
import { CommonService } from "../../../shared/common.service";
import { Router } from "@angular/router";
import {AuthService} from "../../../auth/auth.service"
import { MatSnackBar } from "@angular/material";
import Swal from "sweetalert2";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["../full.component.scss"],
})
export class AppHeaderComponent implements OnInit {
  userData;
  ntervalId: any;
  audio: any;
  interval: any;
  NewOrderCount: boolean = false;
  isLoggingOut = false;
  registeredUser: boolean = false;
  role:any;
  constructor(
    private commonService: CommonService,
    public orderService: OrderService,
    private authService: AuthService,
    private router: Router,
    private _snackBar: MatSnackBar,

      
  ) {}

  ngOnInit() {
    this.userData = this.commonService.getUser();
    setTimeout(() => {
      this.role = localStorage.getItem('role')

    }, 1000);
    console.log(this.role , "role")
    // this.interval = setInterval(() => {
    //   const permissions = this.commonService.getStorage("_per");
    //   if (permissions["order"] == "W") {
    //     this.NewOrder();
    //   }
    // }, 15000);
  }

  play() {
    var audio = new Audio(
      "https://s3.us-east-1.amazonaws.com/throneapp/throne/1629872945548_notification_sound.mp3"
    );
    audio.play();
  }
  NewOrder() {
    this.orderService.getNewOrder("").subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.NewOrderCount =
            res.data.response.isUnassignedSoundNeedsToBeNotified;
          localStorage.setItem(
            "new_or",
            res.data.response.isUnassignedSoundNeedsToBeNotified
          );
          if (this.NewOrderCount == true) {
            this.play();
          }
          // console.log('new order',this.NewOrderCount)
        } else {
        }
      },
      (err) => {}
    );
  }
  // logoutUser() {
  //   this.commonService.logOut();

  // }
  
  

  onLogout() {
    // if(this.role != "admin"){
    //   this.commonService.logOut();
    // }
    this.isLoggingOut = true;
    // debugger
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to log out?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#8F25F8', // Your theme color
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, log me out',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        if(this.role == 'admin'){
          this.authService.logout().subscribe(
            (response) => {
              localStorage.clear();
              sessionStorage.clear();
      
              this.registeredUser = false;
      
              // this._snackBar.open("Logged out successfully", "", {
              //   duration: 3000,
              //   horizontalPosition: "right",
              //   verticalPosition: "top",
              //   panelClass: ["success"],
              // });
    
              Swal.fire("Success", "Logged out successfully", "success");
              this.router.navigate(["/auth/login"]);
            },
            (error) => {
              console.error("Logout failed", error);
              // this._snackBar.open("Logout failed. Please try again.", "", {
              //   duration: 3000,
              //   horizontalPosition: "right",
              //   verticalPosition: "top",
              //   panelClass: ["error"],
              // });

              Swal.fire("error", "Logout failed. Please try again.", "error");

              this.isLoggingOut = true;
            }
          );
        }
        else if (this.role == 'dispatcher'){
          this.commonService.logOut();
        }
    
        // Optional: Show success message after logout
        Swal.fire('Success', 'Logged out successfully', 'success');
      }
    });
    
  }
  
}
